<template>
  <bill-define :type="type" :options="options"></bill-define>
</template>

<script>
import BillDefine from './component/BillDefine'
export default {
  name: 'receivablesDefine',
  components: {BillDefine},
  data () {
    return {
      type: 2,
      options: [
        {
          value: 'design',
          label: '设计费'
        }, {
          value: 'project',
          label: '工程款'
        }, {
          value: 'main',
          label: '主材款'
        }, {
          value: 'soft',
          label: '软装款'
        }, {
          value: 'other',
          label: '其他'
        }
      ]
    }
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/receivablesDefine.vue